module.exports = __webpack_public_path__ + "assets_1789978653902/img/pic_8.bc65c1d3.png";